import { fetchWithAuth } from './fetchWithAuth';

export const fetchNoticeList = async (notice_year) => {
  return fetchWithAuth(`/notice?notice_year=${notice_year}`);
};

export const fetchNoticeDetail = async (notice_year, seq_no) => {
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}`);
};

export const fetchActiveNotices = async () => {
  return fetchWithAuth(`/notice/active`);
};

// 등록 처리
export const createNotice = async (form) => {
  return fetchWithAuth(`/notice`, { method: 'POST', body: JSON.stringify(form) });
};

// 수정 처리
export const updateNotice = async (notice_year, seq_no, form) => {
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}`, { method: 'PUT', body: JSON.stringify(form) });
};

// 삭제 처리 (논리)
export const deleteNotice = async (notice_year, seq_no) => {
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}`, { method: 'DELETE' });
};

// 읽음 처리
export const markNoticeRead = async (notice_year, seq_no) => {
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}/read`, { method: 'POST' });
};

export const fetchNoticeFiles = async (notice_year, seq_no) => {
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}/files`);
};

export const uploadNoticeFiles = async (notice_year, seq_no, fileList) => {
  const formData = new FormData();
  Array.from(fileList).forEach(file => formData.append('files', file));
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}/files`, {
    method: 'POST',
    body: formData,
  });
};

export const deleteNoticeFile = async (notice_year, seq_no, file_no) => {
  return fetchWithAuth(`/notice/${notice_year}/${seq_no}/files/${file_no}`, { method: 'DELETE' });
};